import {TypedEvent} from './TypedEvent.interface';
import {TypedPayloadEvent} from './TypedPayloadEvent.interface';

export function createEvent<T extends string>(type: T): TypedEvent<T>;
export function createEvent<T extends string, P>(
  type: T,
  payload: P
): TypedPayloadEvent<T, P>;
export function createEvent(type: string, payload?: object) {
  return payload !== undefined ? {type, payload} : {type};
}
